import React from "react";

export type VimMode = "insert" | "normal" | "command" | "visual";

export interface VimContextValue {
  mode: VimMode;
  command: string;
  setMode: React.Dispatch<React.SetStateAction<VimMode>>;
  konamiMode: boolean;
  isEnabled: boolean;
  toggleVimMode: () => void;
}

export const VimNavContext = React.createContext<VimContextValue | null>(null);
